import React from 'react';
import 'twin.macro';
import { BreadcrumbItem, BreadcrumbDividerIcon } from './BreadcrumbItem';
import { BreadcrumbSubItem } from './BreadcrumbISubtem';
import { Icon } from '@teetsh/app/src/components/Icons/icon';

interface BreadcrumbSubItemProps {
  onClick?: () => void;
  to?: string;
  icon?: Icon;
  id: string;
  text: string;
}

export interface BreadcrumbItemProps {
  items?: BreadcrumbSubItemProps[];
  text: string | React.ReactNode;
  buttonAriaLabel?: string;
  style?: any;
  isLoading?: boolean;
  onClick?: () => void;
  to?: string;
  subItemComponent?: any;
  iconElement?: React.ReactNode;
  mobileText?: string;
  id: string;
}

interface Props {
  items: BreadcrumbItemProps[];
  dividerIcon?: BreadcrumbDividerIcon;
}

export function Breadcrumb(props: Props) {
  const { items, dividerIcon } = props;
  return (
    <nav tw="grow flex md:shrink min-w-0" aria-label="Breadcrumb">
      <ol tw="grow grid grid-cols-2 md:flex items-center min-w-0 space-x-2 md:space-x-2.5">
        {items.map((item, index) => (
          <BreadcrumbItem
            showIcon={index !== 0}
            dividerIcon={dividerIcon}
            key={item.id}
          >
            <BreadcrumbSubItem item={item} />
          </BreadcrumbItem>
        ))}
      </ol>
    </nav>
  );
}
